import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, CheckIcon, SearchIcon, MailIcon, XIcon } from 'lucide-react';
const storeRows = [{
  domain: 'kith.com',
  owner: 'Ronnie F.',
  aov: '$185',
  email: true,
  rating: '4.8'
}, {
  domain: 'allbirds.com',
  owner: 'Tim B.',
  aov: '$110',
  email: true,
  rating: '4.6'
}, {
  domain: 'rothys.com',
  owner: 'Stephen H.',
  aov: '$145',
  email: true,
  rating: '4.5'
}, {
  domain: 'bohme.com',
  owner: 'Vivien B.',
  aov: '$62',
  email: true,
  rating: '4.3'
}, {
  domain: 'shoepalace.com',
  owner: 'John A.',
  aov: '$95',
  email: true,
  rating: '4.2'
}, {
  domain: 'nobullproject.com',
  owner: 'Marcus W.',
  aov: '$130',
  email: true,
  rating: '4.7'
}, {
  domain: 'bdgastore.com',
  owner: 'David K.',
  aov: '$210',
  email: true,
  rating: '4.4'
}, {
  domain: 'dtlr.com',
  owner: 'Glenn C.',
  aov: '$88',
  email: true,
  rating: '4.1'
}];
export function EcommerceHero() {
  const [activeRow, setActiveRow] = useState(2);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveRow(prev => (prev + 1) % storeRows.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative pt-16 pb-24 overflow-hidden bg-white" data-id="element-1108">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1109">
        <a href="#/features" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-900 transition-colors mb-8" data-id="element-1110">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-1111" /> All features
        </a>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1112">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-xl" data-id="element-1113">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-slate-900 mb-6 leading-[1.05]" data-id="element-1114">
              The ultimate <br data-id="element-1115" />
              <span className="text-blue-600" data-id="element-1116">e-commerce leads</span> <br data-id="element-1117" />
              database
            </h1>

            <p className="text-xl text-slate-600 mb-8 max-w-lg leading-relaxed" data-id="element-1118">
              Find e-commerce leads across 14M+ Shopify stores, WooCommerce
              sites, and 400+ other platforms. Get verified store owner emails
              and launch outreach — all in one platform.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-1119">
              <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="px-10 py-4 text-white font-bold bg-blue-600 rounded-full hover:bg-blue-700 transition-colors text-lg text-center" data-id="element-1120">
                Search e-commerce stores
              </a>
            </div>

            {/* Compact Stats */}
            <div className="flex gap-10 pt-6 border-t border-slate-100" data-id="element-1121">
              <div data-id="element-1122">
                <div className="text-2xl font-bold text-slate-900" data-id="element-1123">14M+</div>
                <div className="text-sm text-slate-500" data-id="element-1124">Active stores</div>
              </div>
              <div data-id="element-1125">
                <div className="text-2xl font-bold text-slate-900" data-id="element-1126">400+</div>
                <div className="text-sm text-slate-500" data-id="element-1127">Platforms</div>
              </div>
              <div data-id="element-1128">
                <div className="text-2xl font-bold text-slate-900" data-id="element-1129">900+</div>
                <div className="text-sm text-slate-500" data-id="element-1130">Technologies</div>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Polished Dashboard Illustration */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="relative" data-id="element-1131">
            {/* Subtle glow behind the dashboard */}
            <div className="absolute -inset-4 bg-gradient-to-br from-blue-50 via-transparent to-emerald-50/40 rounded-3xl blur-2xl pointer-events-none" data-id="element-1132" />

            {/* Dashboard container with slight perspective */}
            <div className="relative bg-white rounded-2xl shadow-[0_20px_60px_-15px_rgba(0,0,0,0.15)] border border-slate-200/70 overflow-hidden" style={{
            transform: 'perspective(1200px) rotateY(-2deg) rotateX(1deg)'
          }} data-id="element-1133">
              {/* Minimal App Header */}
              <div className="flex items-center justify-between px-5 py-3 border-b border-slate-100 bg-slate-50/50" data-id="element-1134">
                <div className="flex items-center gap-2.5" data-id="element-1135">
                  <div className="w-6 h-6 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-1136">
                    <div className="w-3 h-3 border-[1.5px] border-white rounded-full" data-id="element-1137" />
                  </div>
                  <span className="text-sm font-bold text-slate-800 tracking-tight" data-id="element-1138">
                    Openmart
                  </span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-1139">
                  <div className="w-2.5 h-2.5 rounded-full bg-slate-200" data-id="element-1140" />
                  <div className="w-2.5 h-2.5 rounded-full bg-slate-200" data-id="element-1141" />
                  <div className="w-2.5 h-2.5 rounded-full bg-slate-200" data-id="element-1142" />
                </div>
              </div>

              {/* Search + Filter Chips */}
              <div className="px-5 py-3.5 border-b border-slate-100 space-y-3" data-id="element-1143">
                <div className="flex items-center gap-2 bg-slate-50 rounded-xl px-4 py-2.5 border border-slate-200/60" data-id="element-1144">
                  <SearchIcon className="w-4 h-4 text-slate-400" data-id="element-1145" />
                  <span className="text-[12px] text-slate-400" data-id="element-1146">
                    Search stores by domain, owner, or category...
                  </span>
                </div>
                <div className="flex items-center gap-2 flex-wrap" data-id="element-1147">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-blue-50 text-blue-700 text-[11px] font-semibold border border-blue-200" data-id="element-1148">
                    <span className="text-blue-400 font-medium" data-id="element-1149">Platform:</span>{' '}
                    Shopify
                    <XIcon className="w-3 h-3 opacity-50" data-id="element-1150" />
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-blue-50 text-blue-700 text-[11px] font-semibold border border-blue-200" data-id="element-1151">
                    <span className="text-blue-400 font-medium" data-id="element-1152">Category:</span>{' '}
                    Apparel
                    <XIcon className="w-3 h-3 opacity-50" data-id="element-1153" />
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-green-50 text-green-700 text-[11px] font-semibold border border-green-200" data-id="element-1154">
                    <MailIcon className="w-3 h-3" data-id="element-1155" />
                    Has verified email
                  </span>
                  <span className="text-[11px] text-slate-400 font-medium ml-1" data-id="element-1156">
                    18,477 results
                  </span>
                </div>
              </div>

              {/* Data Table */}
              <div className="flex-1 min-w-0" data-id="element-1157">
                <table className="w-full text-[11px] text-left" data-id="element-1158">
                  <thead data-id="element-1159">
                    <tr className="border-b border-slate-200/80 bg-slate-50/40" data-id="element-1160">
                      <th className="py-2.5 px-4 font-semibold text-slate-500 whitespace-nowrap" data-id="element-1161">
                        Store
                      </th>
                      <th className="py-2.5 px-3 font-semibold text-slate-500 whitespace-nowrap" data-id="element-1162">
                        Owner
                      </th>
                      <th className="py-2.5 px-3 font-semibold text-slate-500 whitespace-nowrap text-center" data-id="element-1163">
                        Email
                      </th>
                      <th className="py-2.5 px-3 font-semibold text-slate-500 text-right whitespace-nowrap hidden md:table-cell" data-id="element-1164">
                        Avg. ticket
                      </th>
                      <th className="py-2.5 px-3 font-semibold text-slate-500 text-right whitespace-nowrap hidden lg:table-cell" data-id="element-1165">
                        Rating
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-1166">
                    {storeRows.map((row, idx) => <motion.tr key={idx} animate={{
                    backgroundColor: activeRow === idx ? 'rgba(239, 246, 255, 0.8)' : idx % 2 === 0 ? 'rgba(255,255,255,1)' : 'rgba(248,250,252,0.5)'
                  }} transition={{
                    duration: 0.4
                  }} className="border-b border-slate-50" data-id="element-1167">
                        <td className="py-2.5 px-4 whitespace-nowrap" data-id="element-1168">
                          <div className="flex items-center gap-2" data-id="element-1169">
                            <div className="w-5 h-5 rounded-md bg-gradient-to-br from-slate-100 to-slate-50 border border-slate-200/60 flex items-center justify-center text-[8px] font-bold text-slate-600 shrink-0" data-id="element-1170">
                              {row.domain.charAt(0).toUpperCase()}
                            </div>
                            <span className="font-semibold text-slate-800 truncate max-w-[100px]" data-id="element-1171">
                              {row.domain}
                            </span>
                          </div>
                        </td>
                        <td className="py-2.5 px-3 text-slate-600 whitespace-nowrap" data-id="element-1172">
                          {row.owner}
                        </td>
                        <td className="py-2.5 px-3 text-center whitespace-nowrap" data-id="element-1173">
                          {row.email ? <span className="inline-flex items-center gap-0.5 px-2 py-0.5 rounded-full text-[9px] font-semibold bg-green-50 text-green-700 border border-green-200" data-id="element-1174">
                              <CheckIcon className="w-2.5 h-2.5" strokeWidth={3} data-id="element-1175" />
                              Verified
                            </span> : <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[9px] font-medium bg-orange-50 text-orange-600 border border-orange-200" data-id="element-1176">
                              Request
                            </span>}
                        </td>
                        <td className="py-2.5 px-3 text-slate-700 text-right tabular-nums font-semibold hidden md:table-cell" data-id="element-1177">
                          {row.aov}
                        </td>
                        <td className="py-2.5 px-3 text-slate-500 text-right tabular-nums hidden lg:table-cell" data-id="element-1178">
                          {row.rating}
                        </td>
                      </motion.tr>)}
                  </tbody>
                </table>
              </div>

              {/* Footer */}
              <div className="flex items-center justify-between px-4 py-2.5 border-t border-slate-100 bg-slate-50/30" data-id="element-1179">
                <span className="text-[10px] text-slate-400 font-medium" data-id="element-1180">
                  Showing 1–8 of 18,477 stores
                </span>
                <div className="flex items-center gap-1.5" data-id="element-1181">
                  <span className="w-5 h-5 flex items-center justify-center rounded-md bg-blue-600 text-white text-[9px] font-bold" data-id="element-1182">
                    1
                  </span>
                  <span className="w-5 h-5 flex items-center justify-center rounded-md text-slate-400 text-[9px] font-medium hover:bg-slate-100 cursor-pointer" data-id="element-1183">
                    2
                  </span>
                  <span className="w-5 h-5 flex items-center justify-center rounded-md text-slate-400 text-[9px] font-medium hover:bg-slate-100 cursor-pointer" data-id="element-1184">
                    3
                  </span>
                  <span className="text-[9px] text-slate-300 mx-0.5" data-id="element-1185">...</span>
                  <span className="w-5 h-5 flex items-center justify-center rounded-md text-slate-400 text-[9px] font-medium hover:bg-slate-100 cursor-pointer" data-id="element-1186">
                    231
                  </span>
                </div>
              </div>
            </div>

            {/* Floating enrichment card accent — pops out from the dashboard */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 0.6
          }} className="absolute -bottom-4 -right-3 bg-white rounded-xl shadow-[0_12px_40px_-8px_rgba(0,0,0,0.12)] border border-slate-200/60 p-4 w-52 z-10" data-id="element-1187">
              <div className="flex items-center gap-2 mb-3" data-id="element-1188">
                <div className="w-7 h-7 rounded-lg bg-blue-50 border border-blue-100 flex items-center justify-center text-[10px] font-bold text-blue-600" data-id="element-1189">
                  K
                </div>
                <div data-id="element-1190">
                  <div className="text-[11px] font-bold text-slate-900" data-id="element-1191">
                    kith.com
                  </div>
                  <div className="text-[9px] text-slate-400" data-id="element-1192">
                    Enriched profile
                  </div>
                </div>
              </div>
              <div className="space-y-2" data-id="element-1193">
                <div className="flex justify-between items-center" data-id="element-1194">
                  <span className="text-[10px] text-slate-500" data-id="element-1195">Platform</span>
                  <span className="text-[10px] font-semibold text-slate-800" data-id="element-1196">
                    Shopify Plus
                  </span>
                </div>
                <div className="flex justify-between items-center" data-id="element-1197">
                  <span className="text-[10px] text-slate-500" data-id="element-1198">Revenue</span>
                  <span className="text-[10px] font-semibold text-slate-800" data-id="element-1199">
                    $50M+
                  </span>
                </div>
                <div className="flex justify-between items-center" data-id="element-1200">
                  <span className="text-[10px] text-slate-500" data-id="element-1201">Tech stack</span>
                  <div className="flex gap-1" data-id="element-1202">
                    <span className="w-4 h-4 rounded bg-purple-50 border border-purple-100 flex items-center justify-center text-[7px] font-bold text-purple-600" data-id="element-1203">
                      K
                    </span>
                    <span className="w-4 h-4 rounded bg-orange-50 border border-orange-100 flex items-center justify-center text-[7px] font-bold text-orange-600" data-id="element-1204">
                      G
                    </span>
                    <span className="w-4 h-4 rounded bg-blue-50 border border-blue-100 flex items-center justify-center text-[7px] font-bold text-blue-600" data-id="element-1205">
                      F
                    </span>
                  </div>
                </div>
                <div className="flex justify-between items-center" data-id="element-1206">
                  <span className="text-[10px] text-slate-500" data-id="element-1207">Owner</span>
                  <span className="text-[10px] font-semibold text-green-700 flex items-center gap-1" data-id="element-1208">
                    <CheckIcon className="w-2.5 h-2.5" strokeWidth={3} data-id="element-1209" />
                    ronnie@kith.com
                  </span>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}